var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useMemo, useRef } from 'react';
import { getRandomInt } from '../lib/utils';
import { useGetEventsRequest } from '../api/useGetEventsRequest';
import { useQuery } from '@tanstack/react-query';
import { useEventStore } from '../stores/eventStore';
const defaultOptions = {
    onReceiveData: () => { },
    onPoll: () => { },
    onError: () => { },
    skip: false,
};
export const GetEventsKey = 'getEvents';
export const useReceiveEvents = (options = {}) => {
    var _a;
    const { onReceiveData, onPoll, onError, skip } = Object.assign(Object.assign({}, defaultOptions), options);
    const timestampRef = useRef('0');
    const pollInterval = useMemo(() => 900 + getRandomInt(0, 200), []);
    const onCompletedWithLatestTimestamp = useCallback((data) => {
        var _a, _b, _c, _d;
        if (((_a = data.getEvents) === null || _a === void 0 ? void 0 : _a.at(-1)) === null) {
            return;
        }
        const newTimestamp = +((_c = (_b = data.getEvents.at(-1)) === null || _b === void 0 ? void 0 : _b.persistedTimestamp) !== null && _c !== void 0 ? _c : 0);
        if (newTimestamp > 0 &&
            newTimestamp.toString() !== timestampRef.current) {
            timestampRef.current = (newTimestamp - 60000).toString();
        }
        if (((_d = data === null || data === void 0 ? void 0 : data.getEvents) === null || _d === void 0 ? void 0 : _d.length) > 0) {
            onReceiveData(data);
        }
    }, [onReceiveData]);
    const { events } = useEventStore();
    const seenIds = events
        .filter(e => !e.historic && !e.local && e.persistedTimestamp >= timestampRef.current)
        .map(e => e.id);
    const getEventsRequest = useGetEventsRequest();
    const queryResult = useQuery({
        queryKey: [GetEventsKey, timestampRef.current],
        queryFn: ({ queryKey: [, timestamp] }) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const result = yield getEventsRequest({ timestamp, seenIds });
                onCompletedWithLatestTimestamp(result);
                return result;
            }
            catch (e) {
                onError(e);
                throw e;
            }
            finally {
                onPoll();
            }
        }),
        refetchInterval: pollInterval,
        refetchIntervalInBackground: true,
        enabled: !skip,
    });
    return Object.assign(Object.assign({}, queryResult), { data: (_a = queryResult.data) === null || _a === void 0 ? void 0 : _a.getEvents });
};
